import { authFetch } from 'shared/api/authFetch';
import { config } from 'shared/config/config';

const request = async (path, body) => {
  const response = await authFetch(`${config.API_URL}/api/approvals${path}`, body === undefined ? {} : {
    method: 'POST', body: JSON.stringify(body),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(typeof result.detail === 'string' ? result.detail : `Approval request failed (${response.status}).`);
  return result;
};

export const getApproval = (id) => request(`/${encodeURIComponent(id)}`);
export const decideApproval = (id, decision, reason = null, responsePayload = undefined, reviewedBranchState = undefined) =>
  request(`/${encodeURIComponent(id)}/decisions`, { decision, reason, ...(responsePayload ? { response_payload: responsePayload } : {}),
    ...(reviewedBranchState ? { reviewed_branch_state: reviewedBranchState } : {}) });
export const retryApproval = (id) => request(`/${encodeURIComponent(id)}/retry`, {});
export const requestBranchReview = (id, revisionId, contentHash) =>
  request(`/branches/${encodeURIComponent(id)}`, { revision_id: revisionId, content_hash: contentHash });

export const approvalPath = (id) => `/app/inbox?approval=${encodeURIComponent(id)}`;

export const downloadApprovalArtifact = async (approvalId, artifact) => {
  const path = `/api/approvals/${encodeURIComponent(approvalId)}/artifacts/${encodeURIComponent(artifact.file_artifact_id)}/download`;
  const response = await authFetch(`${config.API_URL}${path}`);
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(typeof error.detail === 'string' ? error.detail : 'The file could not be downloaded. Try again.');
  }
  const url = URL.createObjectURL(await response.blob());
  try {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = artifact.filename || 'download';
    anchor.click();
  } finally {
    URL.revokeObjectURL(url);
  }
};
